export const primaryButtonBackground = {
  '&:disabled': {
    backgroundColor: '#B3B3B3',
    color: '#fff'
  },
  '&:hover': {
    backgroundColor: '#BD0017',
    boxShadow: 'none',
    color: '#fff',
    opacity: '70%'
  },
  backgroundColor: '#BD0017',
  boxShadow: 'none',
  height: '42px',
  maxWidth: '400px'
};

export const primaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: '#B3B3B3',
    color: '#fff'
  },
  '&:hover': {
    backgroundColor: '#BD0017',
    boxShadow: 'none',
    color: '#fff',
    opacity: '70%'
  },
  backgroundColor: '#BD0017',
  boxShadow: 'none',
  color: '#fff'
};

export const primaryButton = {
  '&:disabled': {
    backgroundColor: '#B3B3B3',
    color: '#fff'
  },
  '&:hover': {
    backgroundColor: '#BD0017',
    boxShadow: 'none',
    color: '#fff',
    opacity: '70%'
  },
  backgroundColor: '#BD0017',
  boxShadow: 'none',
  color: '#fff'
};

export const secondaryButtonnBackground = {
  '&:hover': {
    backgroundColor: '#FFF',
    boxShadow: 'none',
    opacity: '70%'
  },
  backgroundColor: '#FFF',
  border: '1px solid #BD0017',
  boxShadow: 'none'
};

export const tertiaryButtonBackground = {
  '&:focus': {
    color: '#757575'
  },
  '&:hover': {
    backgroundColor: '#FFF',
    border: '1px solid #757575',
    boxShadow: 'none',
    opacity: '70%'
  },
  backgroundColor: '#FFF',
  border: '1px solid #757575',
  boxShadow: 'none'
};

export const blackButton = {
  '&:focus': {
    bgcolor: 'rgba(34,34,34,0.7)'
  },
  '&:hover': {
    bgcolor: 'rgba(34,34,34,0.7)'
  },
  bgcolor: '#222',
  boxShadow: 'none',
  color: '#FFF'
};

export const blueButton = {
  '&:disabled': {
    backgroundColor: '#B3B3B3',
    color: '#fff'
  },
  '&:focus': {
    bgcolor: 'rgba(10,126,191,0.7)'
  },
  '&:hover': {
    bgcolor: 'rgba(10,126,191,0.7)'
  },
  bgcolor: '#0A7EBF',
  boxShadow: 'none',
  color: '#FFF'
};

export const blueBorderButton = {
  border: '1px solid #0A7EBF',
  color: '#0A7EBF'
};

export const linkColor = {
  '&:hover': {
    color: '#0A7EBF',
    textDecorationColor: '#0A7EBF'
  },
  color: '#222222',
  fontSize: '12px',
  textDecorationColor: '#222222'
};

export const cardBorder = {
  border: '1px solid #DBDBE0'
};

export const grayText = {
  color: '#757575'
};

export const grayPlaceholder = {
  color: '#B3B3B3'
};

export const blackText = {
  color: '#222222'
};

export const gray = '#757575';

export const grayInput = '#B3B3B3';

export const blueGrayText = {
  color: '#808A9F'
};

export const black = '#222222';

export const blue = '#0A7EBF';

export const defaultBackGround = {
  backgroundColor: '#C9C9C9'
};

export const primarycolor = '#BD0017';

export const changeHeaderColorByEnv = (): string => {
  const env = process.env.REACT_APP_ENV;
  if (env === 'dev') {
    return '#760311';
  } else if (env === 'stg') {
    return '#0A7EBF';
  }
  return '#222222';
};
